import http, { prefixUrlAuth } from './index'

const apis = {
  // 登录
  login(data) {
    return http('/login', {
      method: 'post',
      data
    })
  },
  getInfo(data) {
    return http('/info', {
      method: 'POST',
      data
    })
  },
  logout(data) {
    return http(`/${prefixUrlAuth}/kpmg/auth/logout`, {
      method: 'get',
      data
    })
  },
  getToken(data) {
    return http(`/${prefixUrlAuth}/kpmg/auth/refreshAuthState`, {
      method: 'post',
      data
    })
  },
  getStatusCode(data) {
    return http(`/${prefixUrlAuth}/kpmg/auth/getWxAuthState`, {
      method: 'post',
      data
    })
  },
  emailRegister(data) {
    return http(`/${prefixUrlAuth}/kpmg/auth/register`, {
      method: 'post',
      data
    })
  },
  getVerify(data) {
    return http(`/${prefixUrlAuth}/kpmg/auth/getVerifyImg`, {
      requestType: 'verifyImg',
      method: 'post',
      data
    })
  }
}

export default apis
